import './row-separator.scss'

export function RowSeparator() {
  return <div className="RowSeparator" />
}
